export const _en = {
    order: {
        equal: {
            error: "The field {{field}} must have an order equal to the field {{compareField}}."
        },
        not_equal: {
            error: "The {{field}} field must have a different order than the {{compareField}} field."
        },
        greater: {
            error: "The field {{field}} must have a higher order than the field {{compareField}}."
        },
        greater_or_equal: {
            error: "The field {{field}} must have an order greater than or equal to the field {{compareField}}."
        },
        less: {
            error: "The field {{field}} must have a lower order than the field {{compareField}}."
        },
        less_or_equal: {
            error: "The field {{field}} must have a lower order than the field {{compareField}}."
        }
    },
    oneRequiredBetween: {
        error: "The fields {{field}} or {{secondField}} must be filled in."
    },
    isUnique: {
        error: "The value of the field {{field}} must be unique."
    },
    isNoName: {
        error: "You must fill in your ID number before returning to a non-anonymous resource."
    },
    planner: {
        activityDate: {
            error: "The date of the session does not correspond to the date of the day \"{{module}}\"."
        },
        beginHour: {
            courseDifference: {
                error: "The start time must be later than the time indicated in the internship."
            },
            activityConflict: {
                error: "The start time conflicts with the session \"{{activityLabel}}\"."
            },
            endHourConflict: {
                error: "The start time must be earlier than the end time."
            }
        },
        endHour: {
            courseDifference: {
                error: "The end time must be less than or equal to that indicated in the internship."
            },
            activityConflict: {
                error: "The end time conflicts with the session \"{{activityLabel}}\" and overlaps with the breaks {{breaks}}."
            },
            beginHourConflict: {
                error: "The end time must be later than the start time."
            }
        },
        duration: {
            error: "The duration is invalid."
        }
    },
    alphaNumerique: {
        error: "The field {{field}} must be alphanumeric!"
    },
    alpha: {
        error: "The field {{field}} must be a letter"
    },
    minValueIfSet: {
        error: "If specified, the value of the field '{{field}}' must be greater than or equal to {{fieldValue}}."
    },
    AfterImmobilizationDuration: {
        inferieurToZero: {
            error: "{{field}} must be greater than or equal to zero."
        },
        ImmobilizationDurationEqualActivityDuration: {
            error: "The downtime is equal to the duration of the activity: It is not possible to start after {{fieldValue}} minute(s)."
        },
        getOutOfScopeActivityDuration: {
            error: "Immobilization time should not start after {{maxValue}} minute(s)."
        }
    },
    capacity: {
        error: "The maximum capacity of the hardware resource is {{maxCapacity}} place(s). You cannot associate {{capacity}} human resource(s) with it."
    },
    minDate: {
        error: "The date must be later than {{minDate}}."
    },
    availability: {
        overlap: "Two periods of availability cannot overlap."
    },
    betweenMultiple: {
        greater: { error: "{{propertyName}} must be later than {{minimumValue}}." },
        less: { error: "{{propertyName}} must be before {{maxValue}}." }
    },
    durationLimit: {
        error: "{{propertyName}} must be before {{maxValue}}."
    },
    allOrNothingRequired: {
        error: "All these fields must be filled in together: {{fieldsToShow}}"
    }
};
export const _fr = {
    order: {
        equal: {
            error: "Le champ {{field}} doit avoir un ordre égal au champ {{compareField}}."
        },
        not_equal: {
            error: "Le champ {{field}} doit avoir un ordre différent du champ {{compareField}}."
        },
        greater: {
            error: "Le champ {{field}} doit avoir un ordre supérieur au champ {{compareField}}."
        },
        greater_or_equal: {
            error: "Le champ {{field}} doit avoir un ordre supérieur ou égal au champ {{compareField}}."
        },
        less: {
            error: "Le champ {{field}} doit avoir un ordre inférieur au champ {{compareField}}."
        },
        less_or_equal: {
            error: "Le champ {{field}} doit avoir un ordre inférieur au champ {{compareField}}."
        }
    },
    oneRequiredBetween: {
        error: "Les champs {{field}} ou {{secondField}} doivent être renseignés."
    },
    isUnique: {
        error: "La valeur du champ {{field}} doit être unique."
    },
    isNoName: {
        error: "Vous devez remplir le matricule avant de retourner à une ressource non anonyme."
    },
    planner: {
        activityDate: {
            error: "La date de la séance ne correspond pas à la date de la journée \"{{module}}\"."
        },
        beginHour: {
            courseDifference: {
                error: "L'heure de début doit être postérieure à celle renseignée dans le stage."
            },
            activityConflict: {
                error: "L'heure de début est en conflit avec la séance \"{{activityLabel}}\"."
            },
            endHourConflict: {
                error: "L'heure de début doit être antérieure à l'heure de fin."
            }
        },
        endHour: {
            courseDifference: {
                error: "L'heure de fin doit être inférieure ou égale à celle renseignée dans le stage."
            },
            activityConflict: {
                error: "L'heure de fin est en conflit avec la séance \"{{activityLabel}}\" et se superpose aux pauses {{breaks}}."
            },
            beginHourConflict: {
                error: "L'heure de fin doit être postérieure à l'heure de début."
            }
        },
        duration: {
            error: "La durée est invalide."
        }
    },
    alphaNumerique: {
        error: "le champ {{field}}  doit être alphanumérique!"
    },
    alpha: {
        error: "le champ {{field}} doit être une lettre"
    },
    minValueIfSet: {
        error: "Si renseignée, La valeur du champ '{{field}}' doit être supérieure ou égale à {{fieldValue}}."
    },
    AfterImmobilizationDuration: {
        inferieurToZero: {
            error: "{{field}} doit être plus supérieur ou égal à zéro."
        },
        ImmobilizationDurationEqualActivityDuration: {
            error: "La durée d'immobilisation est égale a la durée de l'activité : Il n'est pas possible de commencer après {{fieldValue}} minute(s)."
        },
        getOutOfScopeActivityDuration: {
            error: "Durée d'immobilisation ne devrait pas commencer après {{maxValue}} minute(s)."
        }
    },
    capacity: {
        error: "La capacité maximale de la ressource matérielle est de {{maxCapacity}} place(s). Vous ne pouvez pas associer {{capacity}} ressource(s) humaine(s)."
    },
    minDate: {
        error: "La date doit être ultérieure au {{minDate}}."
    },
    availability: {
        overlap: "Deux périodes de disponibilité ne peuvent pas se superposer."
    },
    betweenMultiple: {

        greater: { error: "La temp de {{propertyName}} doit être ultérieure à {{minimumValue}}." },
        less: { error: "Le temp de {{propertyName}} doit être antérieure à {{maxValue}}." }
    },
    durationLimit: {

        error: "Le temp de {{propertyName}} doit etre antérieur à {{maxValue}}."
    },
    allOrNothingRequired: {
        error: "Tous ces champs doivent être renseignés ensemble :{{fieldsToShow}}"
    }
};